import { GOAL_DIRECTORY_ARCHIVED_PAGE } from '@townsquare/config/routes';
import {
	FAVORITE_VIEWS_COUNT,
	FAVORITE_VIEWS_FAVOURITED_SORT,
	favoriteViewsTqlQuery,
} from '@townsquare/directory-header/resources/directory-favorite-views';
import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import GoalDirectoryQuery, {
	GoalDirectoryQuery as GoalDirectoryQueryType,
} from '../components/__generated__/GoalDirectoryQuery.graphql';

export const goalDirectoryResource = createRelayResource<GoalDirectoryQueryType>({
	resourceType: 'GOAL_DIRECTORY_PAGE_RESOURCE',
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		return {
			query: GoalDirectoryQuery,
			variables: {
				aaid: context.user.accountId,
				workspaceId: context.workspace?.globalId ?? '',
				workspaceUuid: context.workspace?.UUID,
				containerId: context.collabContext?.contextId,
				newGoalFilterResolversEnabled: fg('townsquare_enable_new_directory_filters'),
				includeArchived: routerContext.route.name === GOAL_DIRECTORY_ARCHIVED_PAGE,
				favouriteViewsTql: favoriteViewsTqlQuery(context.user, 'GOAL'),
				favouriteViewsFirst: FAVORITE_VIEWS_COUNT,
				favouriteViewsSort: FAVORITE_VIEWS_FAVOURITED_SORT,
			},
		};
	},
});
